import cls from './Cross.module.scss'
import { CloseIcon } from 'shared/ui/Icon'

export const Cross = (props) => {
    const { onClose } = props

    return (
        <div className={cls.Cross} onClick={onClose}>
            <CloseIcon size={32} />
        </div>
    )
}
